export default {
  club_name: 'HV71',
  club_name_short: 'hv71',
  stadium_name: '',
  staging_url: 'https://hv71.api.fangroup.io',
  prod_url: 'https://hv71.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/hv71',
  club_logo: '/assets/teams/hv71.png',
  app_name: 'hv71',
  websale_name: 'hv71',
  ntb_team_id: 10058,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'hv71',
  monolithEnabled: false,
};
